import textos from "@/tradutors/areaafiliado";
import type { IdiomaArea } from "@/utils/areaAfiliadoFormato";

/** Idioma da página (`pt-br` ou `en`) e os textos da área do afiliado nele. */
export function useAreaAfiliadoTextos() {
  const route = useRoute();
  const idioma = computed<IdiomaArea>(() => (route.params.language === "en" ? "en" : "pt-br"));
  const t = computed(() => (idioma.value === "en" ? textos.ingles : textos.portugues));

  return { idioma, t };
}
